import React, { useState, useEffect } from "react";
import { Progress } from "reactstrap";

const getClassQuemados = (quemados) => {
  return quemados > 5
    ? "bg-danger"
    : quemados >= 1
    ? "bg-warning"
    : "bg-success";
};

const PointUnit = ({ unit }) => {
  let percent = unit.percent ?? 0;

  return (
    <>
      <div
        className={
          "position-absolute translate-middle rounded-circle border border-secondary " +
          getClassQuemados(unit.quemados)
        }
        style={{
          color: "black",
          width: "22px",
          height: "22px",
          fontSize: "11px",
          fontWeight: "bold",
          textAlign: "center",
          verticalAlign: "middle",
          top: "3px",
          left: `${percent}%`,
          display: "inline-block",
          padding: "2px",
          backgroundColor: "transparent",
          zIndex: 3000,
        }}
      >
        {unit.number ?? "-"}
      </div>
    </>
  );
};
export default PointUnit;
